/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import store from '../store'
export default [
  {
    path: '*',
    meta: {
      name: '',
      requiresAuth: true
    },
    redirect: {
      path: '/home'
    }
  },
  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/',
    meta: {
      name: '',
      requiresAuth: false
    },
    component: () => import(`@/views/LoginHome.vue`),
    // redirect if already signed in
    beforeEnter: (to, from, next) => {
      if (store.getters.authorized) {
        next('/home')
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        component: () => import(`@/components/LoginForm.vue`)
      }
    ]
  },
  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/',
    meta: {
      name: '',
      requiresAuth: false
    },
    component: () => import(`@/views/LoginHome.vue`),
    // redirect if already signed in
    beforeEnter: (to, from, next) => {
      if (store.getters.authorized) {
        next('/home')
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        component: () => import(`@/components/LoginForm.vue`)
      }
    ]
  }, // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/register_user',
    meta: {
      name: 'register_user',
      requiresAuth: false
    },
    component: () => import(`@/views/RegisterUserView.vue`),
    children: [
      {
        path: '/register_user',
        name: 'register_user',
        component: () => import(`@/components/RegisterUserForm.vue`)
      },
      {
        path: '/user_terms',
        name: 'user_terms',
        component: () => import(`@/components/RegisterUserTermsForm.vue`)
      },
      {
        path: '/extra_user_terms',
        name: 'extra_user_terms',
        component: () => import(`@/components/RegisterExtraUserTermsForm.vue`)
      },
      {
        path: '/accept_terms',
        name: 'accept_terms',
        component: () => import(`@/components/AcceptTermsForm.vue`)
      },
      {
        path: '/accept_extra_terms',
        name: 'accept_extra_terms',
        component: () => import(`@/components/AcceptExtraTermsForm.vue`)
      }
    ]
  },
  {
    path: '/register_project_user',
    meta: {
      name: 'register_project_user',
      requiresAuth: false
    },
    component: () => import(`@/views/RegisterProjectUserView.vue`),
    children: [
      {
        path: '/register_project_user',
        name: 'register_project_user',
        component: () => import(`@/components/RegisterProjectUserForm.vue`)
      }
    ]
  },
  {
    path: '/register_success',
    meta: {
      name: 'register_success',
      requiresAuth: false
    },
    component: () => import(`@/views/RegisterSuccessView.vue`),
    children: [
      {
        path: '/register_success',
        name: 'register_success',
        component: () => import(`@/components/RegisterSuccesForm.vue`)
      }
    ]
  },
  {
    path: '/terms_updated',
    meta: {
      name: 'terms_updated',
      requiresAuth: false
    },
    component: () => import(`@/views/TermsUpdatedView.vue`),
    children: [
      {
        path: '/terms_updated',
        name: 'terms_updated',
        component: () => import(`@/components/TermsUpdatedForm.vue`)
      }
    ]
  },
  {
    path: '/token_expired',
    meta: {
      name: 'token_expired',
      requiresAuth: false
    },
    component: () => import(`@/views/TokenExpiredView.vue`),
    children: [
      {
        path: '/token_expired',
        name: 'token_expired',
        component: () => import(`@/components/TokenExpiredForm.vue`)
      }
    ]
  },
  {
    path: '/home',
    meta: {
      name: '',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: '/home',
        component: () => import(`@/components/DashViews/Home.vue`)
      }
    ]
  },
  {
    path: '/matching',
    meta: {
      name: '',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: '/matching',
        component: () => import(`@/components/DashViews/Matching.vue`)
      }
    ]
  },
  {
    path: '/users',
    meta: {
      name: '',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: '/users',
        component: () => import(`@/components/DashViews/UsersTable.vue`)
      }
    ]
  },
  {
    path: '/homes',
    meta: {
      name: '',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: '/homes',
        component: () => import(`@/components/DashViews/HomesTable.vue`)
      }
    ]
  },
  {
    path: '/meters',
    meta: {
      name: '',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: '/meters',
        component: () => import(`@/components/DashViews/DevicesTable.vue`)
      }
    ]
  },
  {
    path: '/projects',
    meta: {
      name: '',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: '/projects',
        component: () => import(`@/components/DashViews/ProjectsTable.vue`)
      }
    ]
  }
  // add any extra routes that you want rendered in the dashboard as a child below. Change toolbar names here
  // {
  //   path: "/home",
  //   meta: {
  //     name: "",
  //     requiresAuth: true,
  //   },
  //   component: () => import(`@/views/DashboardView.vue`),
  //   children: [
  //     {
  //       path: "",
  //       name: "",
  //       component: () => import(`@/components/DashViews/Dashboard.vue`),
  //     },
  //     {
  //       path: "matching",
  //       meta: {
  //         name: "",
  //         requiresAuth: true,
  //       },
  //       component: () => import(`@/components/DashViews/Matching.vue`),
  //     },
  //     {
  //       path: "users",
  //       meta: {
  //         name: "",
  //         requiresAuth: true,
  //       },
  //       component: () => import(`@/components/DashViews/UsersTable.vue`),
  //     },
  //     {
  //       path: "meters",
  //       meta: {
  //         name: "",
  //         requiresAuth: true,
  //       },
  //       component: () => import(`@/components/DashViews/DevicesTable.vue`),
  //     },
  //     {
  //       path: "projects",
  //       meta: {
  //         name: "",
  //         requiresAuth: true,
  //       },
  //       component: () => import(`@/components/DashViews/ProjectsTable.vue`),
  //     },
  //   ],
  // },
]
